/**
 * Redirects to create story via splashcreen.
 * @param brandId
 * @param newsroomId
 * @return {Promise<any> | any}
 */
export function goToStoryCreatePage (brandId, newsroomId) {
  return this.$redirectTo(this.$getUrl(`stories/create?brand=${brandId}&newsroomId=${newsroomId}`, 'hypefactors'), 0, 'hf_story_create')
}
